import React, { useState } from 'react';
import { Link, Stack } from '@mui/material';
import { APP_VERSION } from 'common/config/app';
import { FooterProps } from './Footer.props';
import { StyledRootDiv, StyledSeparator } from './Footer.styles';
import FeatureFlagMenu from '../../../../components/FeatureEnabler/feature-flag-menu/FeatureFlagMenu';

const Footer = ({ shouldDisplayGrayBg = false }: FooterProps) => {
  const [openFeatureFlagMenu, setOpenFeatureFlagMenu] = useState(false);
  const hasFirstLetter = !!(APP_VERSION && APP_VERSION.trim()[0].toUpperCase() === 'V');

  return (
    <>
      <FeatureFlagMenu open={openFeatureFlagMenu} onClose={() => setOpenFeatureFlagMenu(false)} />

      <StyledRootDiv shouldDisplayGrayBg={shouldDisplayGrayBg}>
        <Stack direction={'row'}>
          <p>
            ©{' '}
            <Link component="a" href="https://scalar.io/" target="_blank">
              Scalar Technologies
            </Link>{' '}
            {new Date().getFullYear()} <StyledSeparator>|</StyledSeparator>
            {hasFirstLetter ? '' : 'v'}
          </p>
          <p onDoubleClick={() => setOpenFeatureFlagMenu(true)}>{APP_VERSION}</p>
        </Stack>
      </StyledRootDiv>
    </>
  );
};

export default Footer;
